export default __webpack_public_path__ + "static/media/add-btn-bg.aae2344c.svg";